import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCompareIcon = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 29,
	height: 18,
	viewBox: "0 0 29 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("circle", {
			cx: 9,
			cy: 9,
			r: 8,
			fill: "none",
			strokeWidth: 2
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 20,
			cy: 9,
			r: 8,
			fill: "none",
			strokeWidth: 2
		})
	]
});
const ForwardRef = forwardRef(SvgCompareIcon);
export { ForwardRef as ReactComponent };
